import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import DietSettingsMeasurementsComponentQuery from './DietSettingsMeasurementsComponentQuery';

const DietSettingsMeasurementsComponentConnectorApollo = ({ children }) => {
  const { data, loading, error } = useQuery(DietSettingsMeasurementsComponentQuery);

  const result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.dietSettings = data.me;
  }
  return children(result);
};

DietSettingsMeasurementsComponentConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default DietSettingsMeasurementsComponentConnectorApollo;
